import I18n from 'I18n';
import * as frequencyOptions from 'reporting-data/constants/frequency';
import { getCustomWidgetType } from 'reporting-data/report/reportGetters';
import { CUSTOM_WIDGET_TYPES } from 'reporting-data/tsTypes/customWidgetTypes';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { isReportAccumulative, isTimeSeries
// @ts-expect-error Untyped import
} from 'reporting-ui-components/components/customWidgets/lib/salesAnalytics/helpers';
export const getFrequencyOptions = report => {
  const customWidgetType = getCustomWidgetType(report);
  const isAccumulativeReport = isReportAccumulative(report);
  let frequencyKeys = [frequencyOptions.MONTH];
  if (customWidgetType !== CUSTOM_WIDGET_TYPES.SALES_QUOTA) {
    frequencyKeys = Object.keys(frequencyOptions);
  }
  if (isAccumulativeReport) {
    frequencyKeys = [frequencyOptions.DAY, frequencyOptions.WEEK];
  }
  return frequencyKeys.map(value => ({
    value,
    text: I18n.text(`report-customization-components.customization-components.frequency-dropdown.config.options.${value}`)
  }));
};
export const getIsReportValidForFrequencyDropdown = ({
  report
}) => {
  return isConfigReport(report) && isTimeSeries(report);
};